import { useEffect, useState } from "react";
import { fetchRoster } from "./ApiHelper";

export const ROSTER_CACHE_KEY = "apiRosterV2";

const parseRoster = (serialized) => {
  if (!serialized) return [];
  try {
    const roster = JSON.parse(serialized);
    return Array.isArray(roster) ? roster : [];
  } catch (_) {
    return [];
  }
};

export const readCachedRoster = () => {
  const current = localStorage.getItem(ROSTER_CACHE_KEY);
  return parseRoster(current);
};

export const useRoster = () => {
  const [cacheWasMissing] = useState(() => localStorage.getItem(ROSTER_CACHE_KEY) === null);
  const [roster, setRoster] = useState(readCachedRoster);

  useEffect(() => {
    if (!cacheWasMissing) return undefined;

    let cancelled = false;
    fetchRoster()
      .then((freshRoster) => {
        if (cancelled) return;
        localStorage.setItem(ROSTER_CACHE_KEY, JSON.stringify(freshRoster));
        setRoster(freshRoster);
      })
      .catch((error) => console.error("Roster fetch error:", error.message));

    return () => { cancelled = true; };
  }, [cacheWasMissing]);

  return { roster, setRoster };
};
